module.exports = __webpack_public_path__ + "img/Timer.2f10ebc2.svg";